import { EventTypeInputDelayEventTypeMapBM } from '../types/BusinessModel/EventTypeInputDelayEventTypeMapBM';
import { EventTypeInputDelayEventTypeMap } from '../types/ViewModel/EventTypeInputDelayEventTypeMap';

export class EventTypeInputDelayEventTypeMapFactory {
    constructor() {}

    public newEventTypeInputDelayEventTypeMapList(evTypeListBM: EventTypeInputDelayEventTypeMapBM[]): EventTypeInputDelayEventTypeMap[] {
        const evTypeFilterList: EventTypeInputDelayEventTypeMap[] = [];
        if (evTypeListBM && evTypeListBM.length > 0) {
            evTypeListBM.forEach((cmItem) => {
                evTypeFilterList.push(this.createEventTypeInputDelayEventTypeMapItem(cmItem));
            });
        }
        return evTypeFilterList;
    }

    private createEventTypeInputDelayEventTypeMapItem(item: EventTypeInputDelayEventTypeMapBM): EventTypeInputDelayEventTypeMap {
        return new EventTypeInputDelayEventTypeMap(
            item.eventTypeInputDelayEventTypeMapId,
            item.eventTypeId,
            item.eventTypeInputId,
            item.delayTimeMinutes,
            item.startDelayEventTypeId
        );
    }
}
